import { ImageIcon, Mic } from 'lucide-react'
import { severityLabel, type SurveyFinding } from '../../lib/services/survey'

interface FindingCardProps {
  finding: SurveyFinding
  onClick?: () => void
}

const SEVERITY_COLORS: Record<string, string> = {
  Low: 'bg-emerald-100 text-emerald-700',
  Moderate: 'bg-amber-100 text-amber-700',
  High: 'bg-red-100 text-red-700',
}

export function FindingCard({ finding, onClick }: FindingCardProps) {
  const label = severityLabel(finding.severity)

  return (
    <button
      type="button"
      onClick={onClick}
      className="app-surface w-full text-left p-4 space-y-2 hover:border-[var(--brand-primary)] transition-colors"
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
          {finding.domain} — {finding.standard_ref}
        </span>
        <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${SEVERITY_COLORS[label]}`}>
          {label} ({finding.severity})
        </span>
      </div>

      <p className="text-sm text-slate-800 line-clamp-3">{finding.observation}</p>

      <div className="flex items-center gap-3 text-slate-400">
        <span className="brand-chip">
          {finding.area}
        </span>
        {finding.photo_ids.length > 0 && (
          <span className="flex items-center gap-1 text-xs">
            <ImageIcon size={12} /> {finding.photo_ids.length}
          </span>
        )}
        {finding.audio_transcript && (
          <span className="flex items-center gap-1 text-xs">
            <Mic size={12} /> Voice
          </span>
        )}
      </div>
    </button>
  )
}
